import domContentLoaded from 'dom-content-loaded';
import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

domContentLoaded(() => {
	$(() => {
		$('.js-productSlider').slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 0,
			speed: 5000,
			cssEase: 'linear',
			centerMode: false,
			dots: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			pauseOnHover: false,
		});
	});

	$('.js-productWorkSlider').slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 2000,
		centerMode: true,
		centerPadding: '40px',
		slidesToShow: 4,
		speed: 400,
		// variableWidth: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					// arrows: false,
					centerPadding: '10%',
				},
			},
		],
	});

	// ページ内リンク 目次
	const openBtn = document.querySelector('.un_product_tocOpen');
	const closeBtn = document.querySelector('.un_product_tocNav_close');
	const tocNav = document.querySelector('.un_product_tocNav');

	openBtn.addEventListener('click', () => {
		tocNav.classList.add('is_open');
		openBtn.classList.add('is_hidden');
	});

	closeBtn.addEventListener('click', () => {
		tocNav.classList.remove('is_open');
		openBtn.classList.remove('is_hidden');
	});
});

// フッター固定CTA
window.onload = () => {
	const ctaWrap = document.querySelector('.un_productCTA_sp_wrap');
	const footerTarget = document.querySelector('.un_productFooterCTA_wrap');

	if (!ctaWrap) return;

	const toggleCTA = () => {
		const scrollY = window.scrollY || document.documentElement.scrollTop;

		let footerInView = false;
		if (footerTarget) {
			const rect = footerTarget.getBoundingClientRect();
			footerInView = rect.top < window.innerHeight && rect.bottom > 0;
		}

		if (footerInView) {
			ctaWrap.classList.remove('is_show');
			ctaWrap.classList.add('is_hide');
		} else if (scrollY > 200) {
			ctaWrap.classList.remove('is_hide');
			ctaWrap.classList.add('is_show');
		} else {
			ctaWrap.classList.remove('is_show');
			ctaWrap.classList.add('is_hide');
		}
	};

	window.addEventListener('scroll', toggleCTA);
	toggleCTA();
};
